/**
 * @fileoverview WSF Terminals Cache Flush Date Output Schema
 *
 * Re-exports shared cache flush date output schema for consistency.
 */

export {
  type CacheFlushDateOutput,
  cacheFlushDateOutputSchema,
} from "@/apis/shared/cacheFlushDate";
